import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Alexa Kreizinger --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Vivo destination plugin (Telemetry Pipeline)";
const frontMatter = {
  "title": "Vivo destination plugin (Telemetry Pipeline)",
  "description": "Send pipeline data to Vivo."
};
import YesIcon, {useTOC as useTOC0} from '@/_partials/yes-icon.mdx';
export function useTOC(props) {
  return [{
    value: "Supported telemetry types",
    id: "supported-telemetry-types",
    depth: 2
  }, {
    value: "Configuration parameters",
    id: "configuration-parameters",
    depth: 2
  }, {
    value: "Advanced",
    id: "advanced",
    depth: 3
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    p: "p",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Vivo destination plugin"}</_components.h1>{"\n"}<_components.p>{"The Vivo "}<_components.a href="/pipeline-data/plugins/destination-plugins">{"destination plugin"}</_components.a>{"\n(name: "}<_components.code>{"http"}</_components.code>{", alias: "}<_components.code>{"vivo"}</_components.code>{") lets you configure your telemetry pipeline to send\nyour telemetry data to a remote HTTP endpoint exposed by Vivo Exporter."}</_components.p>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"This plugin for Chronosphere Telemetry Pipeline supports these telemetry types:"}</_components.p>{"\n"}<_components.table><_components.thead><_components.tr><_components.th style={{
    textAlign: "center"
  }}>{"Logs"}</_components.th><_components.th style={{
    textAlign: "center"
  }}>{"Metrics"}</_components.th><_components.th style={{
    textAlign: "center"
  }}>{"Traces"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td style={{
    textAlign: "center"
  }}><YesIcon /></_components.td><_components.td style={{
    textAlign: "center"
  }}><YesIcon /></_components.td><_components.td style={{
    textAlign: "center"
  }}><YesIcon /></_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<_components.p>{"Use the parameters in this section to configure your plugin. The Telemetry Pipeline\nweb interface uses the values in the "}<_components.strong>{"Name"}</_components.strong>{" column to describe the parameters.\nItems in the "}<_components.strong>{"Key"}</_components.strong>{" column are the YAML keys to use in\n"}<_components.a href="/pipeline-configure/config-files">{"pipeline configuration files"}</_components.a>{"."}</_components.p>{"\n"}<_components.h3 id={toc[2].id}>{toc[2].value}</_components.h3>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Name"}</_components.th><_components.th>{"Key"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Default"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.strong>{"Vivo Host"}</_components.strong></_components.td><_components.td><_components.code>{"host"}</_components.code></_components.td><_components.td>{"Required. IP address or hostname of the target HTTP Server."}</_components.td><_components.td><_components.code>{"calyptia-vivo"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.strong>{"Port"}</_components.strong></_components.td><_components.td><_components.code>{"port"}</_components.code></_components.td><_components.td>{"Required. TCP port of the target HTTP Server."}</_components.td><_components.td><_components.code>{"5489"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.strong>{"URI"}</_components.strong></_components.td><_components.td><_components.code>{"uri"}</_components.code></_components.td><_components.td>{"Required. Specifies an optional HTTP URI for the target web server. For example, "}<_components.code>{"/something"}</_components.code>{"."}</_components.td><_components.td><_components.code>{"/sink"}</_components.code></_components.td></_components.tr><_components.tr><_components.td><_components.strong>{"Format"}</_components.strong></_components.td><_components.td><_components.code>{"format"}</_components.code></_components.td><_components.td>{"Required. Specifies the data format to be used in the HTTP request body. Accepted values: "}<_components.code>{"json"}</_components.code>{", "}<_components.code>{"json_lines"}</_components.code>{", "}<_components.code>{"json_stream"}</_components.code>{"."}</_components.td><_components.td><_components.code>{"json"}</_components.code></_components.td></_components.tr></_components.tbody></_components.table></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/pipeline-data/plugins/destination-plugins/vivo',
  {"filePath":"pages/pipeline-data/plugins/destination-plugins/vivo.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)